export var appearanceNoneStyle = "\n  appearance: none;\n";